<template>
  <div class="rh-documentos-secao mt-6">
    <v-divider class="mb-4" />
    <div class="d-flex align-center flex-wrap mb-3">
      <v-icon color="primary" class="mr-2">mdi-paperclip</v-icon>
      <span class="text-subtitle-1 font-weight-bold primary--text mr-2">{{ titulo }}</span>
      <v-chip x-small outlined color="primary">
        {{ itens.length }} {{ itens.length === 1 ? "arquivo" : "arquivos" }}
      </v-chip>
    </div>
    <rh-documentos-uploader
      :titulo="`Adicionar ${titulo.toLowerCase()}`"
      :subtitulo="`${subtitulo} Somente PDF, até 2MB.`"
      :categoria="categoria"
      :itens="itens"
      compacto
      @adicionar="$emit('adicionar-documentos', $event)"
      @remover="$emit('remover-documento', $event)"
      @baixar="$emit('baixar-documento', $event)"
    />
  </div>
</template>

<script>
import RhDocumentosUploader from "./RhDocumentosUploader.vue";

export default {
  name: "RhDocumentosSecao",
  components: { RhDocumentosUploader },
  props: {
    categoria: { type: String, required: true },
    titulo: { type: String, required: true },
    subtitulo: { type: String, default: "" },
    itens: { type: Array, default: () => [] },
  },
};
</script>
